import React from "react";
import { Globe, MapPin, Check } from "lucide-react";
import { WHY } from "../../config/site";
import { Reveal } from "../../lib/site-ui";

const online = ["Available across India", "Live interactive classes", "Personalised doubt support", "Suitable for students anywhere in India"];
const offline = ["One-to-one coaching", "Personalised sessions", "Instructor can travel to the student's location in Mumbai where practical", "Students may also attend sessions at the instructor's location", "Flexible scheduling"];

export const LearnYourWay = () => (
  <section className="py-24 sm:py-32 lg:py-40 border-t border-white/10" data-testid="learn-your-way-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8">
      <div className="mb-14">
        <Reveal as="p" className="label-mono text-slate-500 mb-4">03 — Formats</Reveal>
        <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">Learn Your Way</Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {[{ icon: Globe, title: "ONLINE COACHING", sub: "Across India", items: online },
          { icon: MapPin, title: "OFFLINE PERSONAL COACHING", sub: "Mumbai", items: offline }].map((card, i) => (
          <Reveal key={card.title} delay={i * 0.1}>
            <div className="bg-slate-900/50 border border-white/10 p-8 lg:p-10 h-full hover:bg-slate-900 transition-colors duration-300" data-testid={`format-card-${i}`}>
              <div className="flex items-center gap-4 mb-8">
                <span className="grid place-items-center w-12 h-12 border border-white/15 rounded-sm">
                  <card.icon className="w-5 h-5 text-white" />
                </span>
                <div>
                  <h3 className="font-display text-xl text-white tracking-tight leading-none">{card.title}</h3>
                  <span className="label-mono text-slate-500">{card.sub}</span>
                </div>
              </div>
              <ul className="space-y-4">
                {card.items.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-slate-300 leading-relaxed">
                    <Check className="w-4 h-4 text-slate-500 mt-1 shrink-0" />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const WhyAeroVaid = () => {
  const spans = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-4", "lg:col-span-3"];
  return (
    <section className="py-24 sm:py-32 lg:py-40 border-t border-white/10" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="mb-14">
          <Reveal as="p" className="label-mono text-slate-500 mb-4">04 — Advantage</Reveal>
          <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">Why Choose AeroVaid?</Reveal>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6">
          {WHY.map((w, i) => (
            <Reveal key={w.title} delay={(i % 3) * 0.08} className={spans[i]}>
              <div className="group bg-slate-900/50 border border-white/10 p-8 lg:p-10 h-full hover:border-white/25 transition-colors duration-300 relative overflow-hidden" data-testid={`why-card-${i}`}>
                <span className="font-display text-5xl text-white/5 absolute top-4 right-6 group-hover:text-white/10 transition-colors">0{i + 1}</span>
                <h3 className="font-display text-xl lg:text-2xl text-white mb-3 tracking-tight">{w.title}</h3>
                <p className="text-slate-400 leading-relaxed max-w-md">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
